import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {DashboardComponent} from './demo/view/dashboard.component';
import {DashboardAnalyticsComponent} from './demo/view/dashboardanalytics.component';
import {FormLayoutDemoComponent} from './demo/view/formlayoutdemo.component';
import {InvalidStateDemoComponent} from './demo/view/invalidstatedemo.component';
import {PanelsDemoComponent} from './demo/view/panelsdemo.component';
import {OverlaysDemoComponent} from './demo/view/overlaysdemo.component';
import {MediaDemoComponent} from './demo/view/mediademo.component';
import {MenusDemoComponent} from './demo/view/menusdemo.component';
import {MessagesDemoComponent} from './demo/view/messagesdemo.component';
import {MiscDemoComponent} from './demo/view/miscdemo.component';
import {EmptyDemoComponent} from './demo/view/emptydemo.component';
import {ChartsDemoComponent} from './demo/view/chartsdemo.component';
import {FileDemoComponent} from './demo/view/filedemo.component';
import {DocumentationComponent} from './demo/view/documentation.component';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppContactusComponent} from './pages/app.contactus.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLoginComponent} from './pages/app.login.component';
import {AppLandingComponent} from './pages/app.landing.component';
import {InputDemoComponent} from './demo/view/inputdemo.component';
import {FloatLabelDemoComponent} from './demo/view/floatlabeldemo.component';
import {ButtonDemoComponent} from './demo/view/buttondemo.component';
import {TableDemoComponent} from './demo/view/tabledemo.component';
import {ListDemoComponent} from './demo/view/listdemo.component';
import {AppTimelineDemoComponent} from './pages/app.timelinedemo.component';
import {TreeDemoComponent} from './demo/view/treedemo.component';
import {DisplayComponent} from './utilities/display.component';
import {ElevationComponent} from './utilities/elevation.component';
import {FlexboxComponent} from './utilities/flexbox.component';
import {GridComponent} from './utilities/grid.component';
import {IconsComponent} from './utilities/icons.component';
import {WidgetsComponent} from './utilities/widgets.component';
import {SpacingComponent} from './utilities/spacing.component';
import {TypographyComponent} from './utilities/typography.component';
import {TextComponent} from './utilities/text.component';
import {AppCrudComponent} from './pages/app.crud.component';
import {AppCalendarComponent} from './pages/app.calendar.component';
import {AppInvoiceComponent} from './pages/app.invoice.component';
import {AppHelpComponent} from './pages/app.help.component';
import { AuthGuard } from './_helpers/auth.guard';
import { Role } from './_models/role';

import { PesquisaTituloComponent } from './pages/titulo/pesquisatitulo.component';
import { BancoComponent } from './pages/banco/banco.component';
import { UsuarioComponent } from './pages/usuario/usuario.component';
import { PesquisaClickComponent } from './pages/titulo/pesquisaclick.component';
import { ArquivoComponent } from './pages/arquivo/arquivo.component';
import { SacadoComponent } from './pages/sacado/sacado.component';
import { CarteiraComponent } from './pages/carteira/carteira.component';
import { PerfilComponent } from './pages/administracao/perfil/perfil.component';
import { AplicacaoComponent } from './pages/administracao/aplicacao/aplicacao.component';
import { EmpresaComponent } from './pages/administracao/empresa/empresa.component';
import { FuncionalidadeComponent } from './pages/administracao/funcionalidade/funcionalidade.component';
import { AlterarSenhaComponent } from './pages/usuario/alterarsenha.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '', component: AppMainComponent,
        children: [
          {path: '', component: DashboardComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
          {path: 'favorites/dashboardanalytics', component: DashboardAnalyticsComponent,
          data: {role: Role.User}, canActivate: [AuthGuard]
        },
        {path: 'uikit/formlayout', component: FormLayoutDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/floatlabel', component: FloatLabelDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/invalidstate', component: InvalidStateDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/input', component: InputDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/button', component: ButtonDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/table', component: TableDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/list', component: ListDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/tree', component: TreeDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/panel', component: PanelsDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/overlay', component: OverlaysDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/menu', component: MenusDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/media', component: MediaDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/message', component: MessagesDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/misc', component: MiscDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/charts', component: ChartsDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'uikit/file', component: FileDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/display', component: DisplayComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/elevation', component: ElevationComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/flexbox', component: FlexboxComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/grid', component: GridComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/icons', component: IconsComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/widgets', component: WidgetsComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/spacing', component: SpacingComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/typography', component: TypographyComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'utilities/text', component: TextComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'pages/crud', component: AppCrudComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'pages/calendar', component: AppCalendarComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'pages/timeline', component: AppTimelineDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'pages/invoice', component: AppInvoiceComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'pages/help', component: AppHelpComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'pages/empty', component: EmptyDemoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'documentation', component: DocumentationComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'titulo/pesquisatitulo', component: PesquisaTituloComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'titulo/pesquisaclick', component: PesquisaClickComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'banco/banco', component: BancoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'usuario/usuario', component: UsuarioComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'arquivo/arquivo', component: ArquivoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'sacado/sacado', component: SacadoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'carteira/carteira', component: CarteiraComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'administracao/perfil/perfil', component: PerfilComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'administracao/aplicacao/aplicacao', component: AplicacaoComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'administracao/empresa/empresa', component: EmpresaComponent, data: {role: Role.User}, canActivate: [AuthGuard] },
        {path: 'administracao/funcionalidade/funcionalidade', component: FuncionalidadeComponent, data: {role: Role.User},
        canActivate: [AuthGuard] }
      ]
    },
    {path: 'error', component: AppErrorComponent},
    {path: 'access', component: AppAccessdeniedComponent},
    {path: 'notfound', component: AppNotfoundComponent},
    {path: 'contactus', component: AppContactusComponent},
    {path: 'login', component: AppLoginComponent},
    {path: 'usuario/alterarsenha', component: AlterarSenhaComponent }, 
    {path: 'landing', component: AppLandingComponent},
    {path: '**', redirectTo: '/notfound'},
  ], {scrollPositionRestoration: 'enabled'})
],
exports: [RouterModule]
})
export class AppRoutingModule {
}
